import React, { useEffect, useState } from 'react';
import { Header } from '../../components/Header/Header';
import { Footer } from '../../components/Footer/Footer';
import { Link } from 'react-router-dom';
import { hasJogoAtivo } from '../../../db/db';
import { useAuth } from '../../../context/AuthContext';
import './Home.css'; 

const Home = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [jogoAtivo, setJogoAtivo] = useState(false);
  const [isInstallButtonVisible, setIsInstallButtonVisible] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e); // Guarda o evento para usar quando o usuário clicar no botão
      setIsInstallButtonVisible(true); // Exibe o botão de instalação
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  useEffect(() => {
    async function checkJogoAtivo() {
      const hasPlayers = await hasJogoAtivo();
      setJogoAtivo(hasPlayers);
    }
    checkJogoAtivo();
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Exibe o prompt de instalação
      const choiceResult = await deferredPrompt.userChoice;
      if (choiceResult.outcome === 'accepted') {
        console.log('Usuário aceitou a instalação do PWA');
      } else {
        console.log('Usuário recusou a instalação do PWA');
      }
      setDeferredPrompt(null); // Reseta o prompt após o uso
      setIsInstallButtonVisible(false); // Oculta o botão após a resposta do usuário
    }
  };

  return (
    <>
      <Header/>
      
      <div className='body'>
        <div className='center'>
          <div className='body-content card'>
            <div className='area-menu-home'>
              {!user && <Link className='btn-default' to="/login">Login</Link>}
              <Link className='btn-default' to="/turmas">Turmas</Link>
              {!jogoAtivo && (
                <Link className='btn-default' to="/novo-amistoso">Novo amistoso</Link>
              )}
              {jogoAtivo && (
                <div className='home-live-card home-live-card--fixed'>
                  <Link to="/novo-amistoso/jogo-em-andamento" className='home-live-info'>
                      <span className="live-pulse-dot" aria-hidden="true"></span>
                      <p>Jogo em andamento</p>
                  </Link>
                </div>
              )}
            </div>
            
            {isInstallButtonVisible && (
            <button className='btn-default' onClick={handleInstallClick}>Instalar App</button>
            )}
          </div>
        </div>
      </div>

      <Footer/>
    </>
  );
};

export default Home;
